import { render, staticRenderFns } from "./WhatsAppButton.vue?vue&type=template&id=0adc730d&scoped=true&"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js&"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppButton.vue?vue&type=style&index=0&id=0adc730d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc730d",
  null
  
)

export default component.exports